import { useEffect, useState } from "react";
import { ReactComponent as AutochapeauLogo } from "../assets/autochapeau.svg";

interface Props {
  loading?: boolean;
}

/** Transform 1s + light 1.05s + text ~2.38s + buffer */
const PRELOADER_ANIMATION_MS = 3000;

const Preloader = ({ loading = false }: Props) => {
  const [mountedAt, setMountedAt] = useState<number | null>(null);
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    if (loading) {
      setMountedAt(Date.now());
      setVisible(true);
      return;
    }
    if (!visible) return;
    const now = Date.now();
    const elapsed = mountedAt ? now - mountedAt : PRELOADER_ANIMATION_MS;
    const remaining = Math.max(0, PRELOADER_ANIMATION_MS - elapsed);
    const timer = window.setTimeout(() => {
      setVisible(false);
    }, remaining);
    return () => window.clearTimeout(timer);
  }, [loading, visible, mountedAt]);

  if (!visible) {
    return <></>;
  }

  return (
    <div
      className="ac-preloader"
      role="status"
      aria-live="polite"
      style={
        {
          "--ac-preloader-duration": `${PRELOADER_ANIMATION_MS}ms`,
        } as React.CSSProperties
      }
    >
      <div className="ac-preloader__inner">
        <div className="ac-preloader__logo" aria-hidden>
          <AutochapeauLogo />
        </div>
        <div className="ac-preloader__progress" aria-hidden="true">
          <div className="ac-preloader__progress-track">
            <div className="ac-preloader__progress-fill" />
          </div>
        </div>
        <span className="ac-preloader__text">AUTOCHAPEAU</span>
      </div>
    </div>
  );
};

export default Preloader;
